<template>
    <div class="text-md-left" >
        <el-row>
            <el-col :span="24" v-if="listLog.length > 0">
                <el-collapse v-model="activeUserInfo" accordion>
                <el-collapse-item v-for="(item,index) in listLog" :key="index" :name="index">
                    <template slot="title">
                        <span><b>{{item.logDetail.timestamp}}</b></span>
                        <span>&nbsp;แก้ไขโดย : <b>{{item.logDetail.editorEmail}}</b></span>
                        <span>&nbsp;สาเหตุ : <b>{{item.logDetail.editorValue}}</b></span>
                    </template>

                <!-- Shop Info -->
                <el-row v-if="item.shopInfo.diffCheck">
                    <el-col :span="24">
                        <b><u>ข้อมูลร้านค้า</u></b>
                        <div v-for="(itemDiff,index) in item.shopInfo.diffResult" :key="index">
                            <span>- แก้ <b>{{pathName(itemDiff.path[0])}}</b> จาก <b>{{pathValue(itemDiff.path[0],itemDiff.lhs)}}</b> เป็น <b>{{pathValue(itemDiff.path[0],itemDiff.rhs)}}</b> </span>
                        </div>
                    </el-col>
                </el-row>
                <!-- Shop Bank -->
                <el-row v-if="item.shopBank.diffCheck">
                    <el-col :span="24">
                        <b><u>ข้อมลทางบัญชี</u></b>
                        <div v-for="(itemDiff,index) in item.shopBank.diffResult" :key="index">
                            <span>- แก้ <b>{{pathName(itemDiff.path[0])}}</b> จาก <b>{{pathValue(itemDiff.path[0],itemDiff.lhs)}}</b> เป็น <b>{{pathValue(itemDiff.path[0],itemDiff.rhs)}}</b> </span>
                        </div>
                    </el-col>
                </el-row>
                <!-- Courier Limit -->
                <el-row :gutter="20" v-if="item.courierLimit.diffCheck">
                    <el-col :span="24">
                        <b><u>ข้อมูลจำกัดจำนวนออเดอร์ขนส่ง</u></b>
                    </el-col>
                    <el-col :span="12">
                        <el-table
                            :data="item.courierLimit.diffResult.lhs"
                            :header-cell-style="{'background-color': 'black', 'color': 'white', 'text-align': 'center'}"
                            style="width: 100%;padding-top:10px">
                            <el-table-column label="ขนส่ง" >
                                <div class="text-md-left" slot-scope="scope">{{getCourier(scope.row.courierId)}}</div>
                            </el-table-column>
                            <el-table-column label="จำนวนชิ้น / วัน" >
                                <div class="text-md-center" slot-scope="scope">{{scope.row.limit}}</div>
                            </el-table-column>
                        </el-table>
                    </el-col>
                    <el-col :span="12">
                        <el-table
                            :data="item.courierLimit.diffResult.rhs"
                            :header-cell-style="{'background-color': 'black', 'color': 'white', 'text-align': 'center'}"
                            style="width: 100%;padding-top:10px">
                            <el-table-column label="ขนส่ง" >
                                <div class="text-md-left" slot-scope="scope">{{getCourier(scope.row.courierId)}}</div>
                            </el-table-column>
                            <el-table-column label="จำนวนชิ้น / วัน" >
                                <div class="text-md-center" slot-scope="scope">{{scope.row.limit}}</div>
                            </el-table-column>
                        </el-table>
                    </el-col>
                </el-row>
                <!-- weightRate (Size Toggle-tab) -->
                <el-row v-if="item.dimensionRate.diffCheck">
                    <el-col :span="24">
                        <b><u>ข้อมูลคิดบริการน้ำหนัก (Size Toggle-tab)</u></b>
                        <div v-for="(itemDiff,index) in item.dimensionRate.diffResult" :key="index">
                            <span v-if="itemDiff.kind === 'E'">
                                <b>{{itemDiff.path[1]}}</b> แก้ไข <b>{{itemDiff.path[3]}}</b> ลำดับที่ <b>{{itemDiff.path[2] + 1}}</b> จาก  <b>{{itemDiff.lhs}}</b> เป็น <b>{{itemDiff.rhs}}</b>
                            </span>
                            <span v-else-if="itemDiff.kind === 'A'">
                                <span v-if="itemDiff.item.kind === 'D'">
                                    <b>{{itemDiff.path[1]}}</b> ลบ ลำดับที่ <b>{{itemDiff.index + 1}}</b>
                                    Max : <b>{{itemDiff.item.lhs.max}}</b> Min : <b>{{itemDiff.item.lhs.min}}</b> Rate Bkk : <b>{{itemDiff.item.lhs.rateBkk}}</b> Rate Upc : <b>{{itemDiff.item.lhs.rateUpc}}</b>
                                </span>
                                <span v-else-if="itemDiff.item.kind === 'N'">
                                    <b>{{itemDiff.path[1]}}</b> เพิ่ม ลำดับที่ <b>{{itemDiff.index + 1}}</b>
                                    Max : <b>{{itemDiff.item.rhs.max}}</b> Min : <b>{{itemDiff.item.rhs.min}}</b> Rate Bkk : <b>{{itemDiff.item.rhs.rateBkk}}</b> Rate Upc : <b>{{itemDiff.item.rhs.rateUpc}}</b>
                                </span>
                            </span>
                        </div>
                    </el-col>
                </el-row>
                <!-- weightRate (weight Toggle-tab) -->
                <el-row v-if="item.weightRate.diffCheck">
                    <el-col :span="24">
                        <b><u>ข้อมูลคิดบริการน้ำหนัก (Weight Toggle-tab)</u></b>
                        <div v-for="(itemDiff,index) in item.weightRate.diffResult" :key="index">
                            <span v-if="itemDiff.kind === 'E'">
                                <b>{{itemDiff.path[1]}}</b> แก้ไข <b>{{itemDiff.path[3]}}</b> ลำดับที่ <b>{{itemDiff.path[2] + 1}}</b> จาก  <b>{{itemDiff.lhs}}</b> เป็น <b>{{itemDiff.rhs}}</b>
                            </span>
                            <span v-else-if="itemDiff.kind === 'A'">
                                <span v-if="itemDiff.item.kind === 'D'">
                                    <b>{{itemDiff.path[1]}}</b> ลบ ลำดับที่ <b>{{itemDiff.index + 1}}</b>
                                    Max : <b>{{itemDiff.item.lhs.max}}</b> Min : <b>{{itemDiff.item.lhs.min}}</b> Rate Bkk : <b>{{itemDiff.item.lhs.rateBkk}}</b> Rate Upc : <b>{{itemDiff.item.lhs.rateUpc}}</b>
                                </span>
                                <span v-else-if="itemDiff.item.kind === 'N'">
                                    <b>{{itemDiff.path[1]}}</b> เพิ่ม ลำดับที่ <b>{{itemDiff.index + 1}}</b>
                                    Max : <b>{{itemDiff.item.rhs.max}}</b> Min : <b>{{itemDiff.item.rhs.min}}</b> Rate Bkk : <b>{{itemDiff.item.rhs.rateBkk}}</b> Rate Upc : <b>{{itemDiff.item.rhs.rateUpc}}</b>
                                </span>
                            </span>
                        </div>
                    </el-col>
                </el-row>
                <!-- service -->
                <el-row v-if="item.service.diffCheck">
                    <el-col :span="24">
                        <b><u>ข้อมูลร้านค้า</u></b>
                        <div v-for="(itemDiff,index) in item.service.diffResult" :key="index">
                            <span>- แก้ <b>{{itemDiff.path[0]}}</b> จาก <b>{{itemDiff.lhs}}</b> เป็น <b>{{itemDiff.rhs}}</b> </span>
                        </div>
                    </el-col>
                </el-row>
                <!-- financeConfig -->
                <el-row v-if="item.financeConfig.diffCheck">
                    <el-col :span="24">
                        <b><u>financeConfig</u></b>
                        <div v-for="(itemDiff,index) in item.financeConfig.diffResult" :key="index">
                            <span v-if="itemDiff.path[2] === 'bkkZone'">
                                <span v-if="itemDiff.kind === 'A'">
                                    <span v-if="itemDiff.item.kind === 'N'">
                                        <b>bkkZone : {{itemDiff.path[1]}}</b> เพิ่ม <b>{{itemDiff.item.rhs}}</b>
                                    </span>
                                    <span v-else-if="itemDiff.item.kind === 'D'">
                                        <b>bkkZone : {{itemDiff.path[1]}}</b> ลบ <b>{{itemDiff.item.lhs}}</b>
                                    </span>
                                </span>
                                <span v-else-if="itemDiff.kind === 'E'">
                                    <b>bkkZone : {{itemDiff.path[1]}}</b> แก้ไข จาก <b>{{itemDiff.lhs}}</b> เป็น <b>{{itemDiff.rhs}}</b>
                                </span>
                            </span>
                            <span v-else-if="itemDiff.path[2] === 'remoteZone'">
                                <span v-if="itemDiff.path[3] === 'cost'">
                                    <b>RomoteZone ค่าบริการพื้นที่ห่างไกล : {{itemDiff.path[1]}}</b> แก้ไข จาก <b>{{itemDiff.lhs}}</b> เป็น <b>{{itemDiff.rhs}}</b>
                                </span>
                                <span v-else>
                                    <span v-if="itemDiff.kind === 'N'">
                                        <b>RomoteZone ZipCode : {{itemDiff.path[1]}}</b> เพิ่ม <b>{{itemDiff.path[3]}}</b>
                                    </span>
                                    <span v-else-if="itemDiff.kind === 'D'">
                                        <b>RomoteZone ZipCode : {{itemDiff.path[1]}}</b> ลบ <b>{{itemDiff.path[3]}}</b>
                                    </span>
                                </span>
                            </span>
                            <span v-else-if="itemDiff.path[2] === 'cod'">
                                <span v-if="itemDiff.kind === 'E'">
                                    <span v-if="itemDiff.path[3] === 'minimumCod'">
                                        <b>COD ขั้นต่ำ: {{itemDiff.path[1]}}</b> แก้ไข จาก <b>{{itemDiff.lhs}}</b> เป็น <b>{{itemDiff.rhs}}</b>
                                    </span>
                                    <span v-if="itemDiff.path[3] === 'serviceCharge'">
                                        <span v-if="itemDiff.path[4] ==='type'">
                                            <b>COD ค่าบริการ: {{itemDiff.path[1]}}</b> แก้ไข Type จาก <b>{{getTypeCod(itemDiff.lhs)}}</b> เป็น <b>{{getTypeCod(itemDiff.rhs)}}</b>
                                        </span>
                                        <span v-else-if="itemDiff.path[4] ==='percent'">
                                            <b>COD ค่าบริการ: {{itemDiff.path[1]}}</b> แก้ไข percent จาก <b>{{itemDiff.lhs}}%</b> เป็น <b>{{itemDiff.rhs}}%</b>
                                        </span>
                                        <span v-else-if="itemDiff.path[4] ==='value'">
                                            <b>COD ค่าบริการ: {{itemDiff.path[1]}}</b> แก้ไข value จาก <b>{{itemDiff.lhs}} บาท</b> เป็น <b>{{itemDiff.rhs}}บาท</b>
                                        </span>
                                    </span>

                                </span>
                            </span>
                        </div>
                    </el-col>
                </el-row>
                </el-collapse-item>
            </el-collapse>
            </el-col>
            <el-col :span="24" v-else class="text-md-center">
                <span style="font-size:24px;">ไม่มีประวัติการแก้ไข</span>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import diff from 'deep-diff'
export default {
    name: 'LogHistoryShopDialog',
    props: {
        data: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            listLog: [],
            activeUserInfo: 0
        }
    },
    mounted () {
        this.fetchHistory()
    },
    methods: {
        async fetchHistory () {
            this.listLog = []
            let loading = this.$loading({
                target: '.el-dialog__body',
                text: 'Loading Log Shop'
            })
            try {
                let param = {
                    shop_id: this.data.shopDetail.shopId
                }
                let res = await fgApi.log.getLogEditShop(param)
                if (res.success) {
                    await this.historyConvert(res.data)
                }
            } catch (error) {
                console.log(error)
            }
            loading.close()
        },
        mapKey (data, keyArray) {
            let diffData = {
                lhs: {},
                rhs: {}
            }
            for (let key of keyArray) {
                diffData.lhs[key] = data.payload.lhs[key]
                diffData.rhs[key] = data.payload.rhs[key]
            }
            let diffResult = diff(diffData.lhs, diffData.rhs)
            if (diffResult) {
                diffResult = { diffResult, diffCheck: true }
            } else {
                diffResult = { diffResult, diffCheck: false }
            }
            return diffResult
        },
        async historyConvert (data) {
            console.log('data --->', data)
            let logHistory = []
            for await (let [index, log] of data.entries()) {
                console.log(index, log)
                let logDetail = {
                    timestamp: this.$dayjs.unix(log.timestamp).format('YYYY-MM-DD HH:mm:ss'),
                    editorEmail: log.editorEmail,
                    editorValue: log.editorValue
                }
                // Shop Info
                let keyShopInfo = ['name', 'shopCode', 'phoneNumber', 'address', 'province', 'district', 'subDistrict', 'goodsType', 'line', 'facebook', 'instagram', 'zipcode', 'activeUploadSlip', 'legalName', 'pickedUpDistrict', 'pickedUpProvince', 'pickedUpSubDistrict', 'pickedUpAddress', 'pickedUpZipcode', 'facebookPageId', 'autoSendMessage']
                let shopInfo = this.mapKey(log, keyShopInfo)
                // console.log('shopInfo Diff ->', shopInfo)

                // Shop Bank
                let keyShopBank = ['bankAccountType', 'bankAccountName', 'taxId', 'bankAccountEmail', 'bankAccountAddress', 'bankAccountSubDistrict', 'bankAccountDistrict', 'bankAccountProvince', 'bankAccountNumber', 'bankName', 'bankAccountZipcode']
                let shopBank = this.mapKey(log, keyShopBank)
                // console.log('shopBank Diff ->', shopBank)

                // Courier Limit
                let keyCourierLimt = ['courierLimitDay']
                let courierLimit = this.mapKey(log, keyCourierLimt)
                let courierLimitResult = { diffResult: { lhs: log.payload.lhs.courierLimitDay, rhs: log.payload.rhs.courierLimitDay }, diffCheck: courierLimit.diffCheck }
                // console.log('courierLimit Diff ->', courierLimitResult)

                // dimensionRate

                let keyDimensionRate = ['dimensionRate']
                let dimensionRate = this.mapKey(log, keyDimensionRate)
                // weightRate
                let keyWeightRate = ['weightRate']
                let weightRate = this.mapKey(log, keyWeightRate)
                // console.log('weightRate Diff ->', weightRate)

                // dimWeightMultiplier
                let keyService = ['dimWeightMultiplier']
                let service = this.mapKey(log, keyService)
                // console.log('service Diff ->', service)

                // financeConfig
                let keyFinanceConfig = ['financeConfig']
                let financeConfig = this.mapKey(log, keyFinanceConfig)
                // console.log('financeConfig Diff ->', financeConfig)
                logHistory.push({ logDetail, shopInfo: shopInfo, shopBank: shopBank, courierLimit: courierLimitResult, weightRate: weightRate, dimensionRate: dimensionRate, service: service, financeConfig: financeConfig })
            }
            console.log('Log', logHistory)
            this.listLog = logHistory
        },
        pathName (path) {
            let pathName = {
                activeUploadSlip: 'อัพโหลดสลิป',
                address: 'ที่อยู่ร้าน',
                bankAccountAddress: 'ที่อยู่ทางบัญชี',
                bankAccountDistrict: 'อำเภอ',
                bankAccountEmail: 'อีเมล์สำหรับบัญชี',
                bankAccountName: 'ชื่อบัญชี',
                bankAccountNumber: 'หมายเลขบัญชีธนาคาร',
                bankAccountProvince: 'จังหวัด',
                bankAccountSubDistrict: 'ตำบล',
                bankAccountType: 'ประเภทบัญชี',
                bankAccountZipcode: 'รหัสไปรษณีย์ร้านค้า',
                bankName: 'บัญชีธนาคาร',
                courierLimitDay: 'courierLimitDay',
                dimWeightMultiplier: 'dimWeightMultiplier',
                district: 'อำเภอ',
                facebook: 'FACEBOOK',
                financeConfig: 'financeConfig',
                goodsType: 'ประเภทร้านค้า',
                instagram: 'INSTAGRAM',
                line: 'LINE',
                name: 'ชื่อร้าน',
                phoneNumber: 'เบอร์โทรร้าน',
                province: 'จังหวัด',
                shopCode: 'Shop Code',
                subDistrict: 'ตำบล',
                taxId: 'เลขประจำตัวผู้เสียภาษี',
                dimensionRate: 'dimensionRate',
                weightRate: 'weightRate',
                zipcode: 'รหัสไปรษณีย์ร้านค้า',
                facebookPageId: 'รหัสเพจ',
                autoSendMessage: 'ส่งข้อความอัตโนมัติ'
            }
            if (pathName.hasOwnProperty(path)) {
                return pathName[path]
            } else {
                return path
            }
        },
        pathValue (path, value) {
            if (path === 'goodsType') {
                return this.getShopGoodsType(value)
            } else if (path === 'bankAccountType') {
                return this.getBankAccountType(value)
            } else if (path === 'bankName') {
                return this.getBank(value)
            } else {
                return value
            }
        }
    }
}
</script>
